import { Link, useRouterState } from "@tanstack/react-router";
import clsx from "clsx";
import { MAIL_APP, OTHER_APPS } from "./nav";
import s from "./MobileNav.module.css";

export function MobileNav() {
  const path = useRouterState({ select: (st) => st.location.pathname });
  return (
    <nav className={s.nav} aria-label="Apps">
      <Link to="/mail/$folder" params={{ folder: "inbox" }} className={clsx(s.item, path.startsWith("/mail") && s.active)} aria-current={path.startsWith("/mail") ? "page" : undefined}>
        <span className={s.icon}>
          <MAIL_APP.icon />
        </span>
        <span>{MAIL_APP.label}</span>
      </Link>
      {OTHER_APPS.map((a) => {
        const active = path.startsWith(a.to);
        return (
          <Link key={a.to} to={a.to} className={clsx(s.item, active && s.active)} aria-current={active ? "page" : undefined}>
            <span className={s.icon}>
              <a.icon />
            </span>
            <span>{a.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
